import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    backgroundColor: theme.palette.custom.background.area,
    boxShadow: theme.shadows[25],
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
    transition: theme.transitions.create(),

    '&:hover': {
      boxShadow: theme.shadows[8],
    },

    [theme.breakpoints.up('md')]: {
      alignItems: 'center',
      height: theme.spacing(8),
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      alignItems: 'flex-start',
      padding: theme.spacing(2, 0),
    },

    '& .appointment': {
      '&-icon': {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 3),
        color: theme.palette.primary.main,

        '&.concluded': {
          color: theme.palette.custom.feedback.positive,
        },
        '&.info-absence': {
          color: theme.palette.custom.feedback.warning,
        },
        '&.absent': {
          color: theme.palette.custom.feedback.negative,
        },
        '&.canceled': {
          color: theme.palette.text.disabled,
        },

        [theme.breakpoints.down('sm')]: {
          minHeight: theme.spacing(5),
        },
      },
      '&-infos-container': {
        display: 'flex',
        flexGrow: 1,
        [theme.breakpoints.up('md')]: {
          alignItems: 'center',
        },
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column',
        },

        '&.canceled': {
          opacity: 0.6,
        },
      },
      '&-date': {
        flexGrow: 1,
        width: '100%',
        minWidth: 120,
        [theme.breakpoints.up('md')]: {
          padding: theme.spacing(0, 1, 0, 0),
        },
      },
      '&-professional': {
        width: '100%',
        flexGrow: 2,
        '&-label': {
          color: theme.palette.text.hint,
        },
        [theme.breakpoints.up('md')]: {
          padding: theme.spacing(0, 1),
        },
        [theme.breakpoints.down('sm')]: {
          marginTop: theme.spacing(2),
        },
      },
      '&-status': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        flexGrow: 2,
        [theme.breakpoints.up('md')]: {
          padding: theme.spacing(0, 1),
        },
        [theme.breakpoints.down('sm')]: {
          marginTop: theme.spacing(2),
        },

        '&-label': {
          display: 'flex',
          alignItems: 'center',
          height: theme.spacing(3),
          borderRadius: theme.shape.borderRadius,
          padding: theme.spacing(0, 1),
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.getContrastText(theme.palette.primary.main),

          '&.concluded': {
            backgroundColor: theme.palette.custom.feedback.positive,
            color: theme.palette.getContrastText(
              theme.palette.custom.feedback.positive,
            ),
          },
          '&.info-absence': {
            backgroundColor: theme.palette.custom.feedback.warning,
            color: theme.palette.getContrastText(
              theme.palette.custom.feedback.warning,
            ),
          },
          '&.absent': {
            backgroundColor: theme.palette.custom.feedback.negative,
            color: theme.palette.getContrastText(
              theme.palette.custom.feedback.negative,
            ),
          },
          '&.canceled': {
            backgroundColor: theme.palette.grey[300],
            color: theme.palette.getContrastText(theme.palette.grey[300]),
          },

          '&-icon': {
            fontSize: 18,
            marginLeft: theme.spacing(1),
          },
        },
        [`
          &-link,
          &-rating,
          &-btn-rating
        `]: {
          marginLeft: theme.spacing(3),
        },
        '&-btn-rating': {
          cursor: 'pointer',
        },
      },
      '&-actions': {
        padding: theme.spacing(0, 1),
        '&-btn': {
          color: theme.palette.text.icon,
        },
        '&-menu': {
          '&-item': {
            minHeight: theme.spacing(5),
            '&-icon': {
              marginRight: theme.spacing(1),
            },
            '&-text': {
              color: theme.palette.text.secondary,
            },
          },
        },
      },
    },
  },
  actionsMenu: {
    '& .actions-menu': {
      '&-item': {
        minHeight: theme.spacing(6),
        '&-icon': {
          marginRight: theme.spacing(2),
          color: theme.palette.text.hint,
        },
        '&-text': {
          color: theme.palette.text.secondary,
        },
      },
    },
  },
}));

export default styles;
